/**
 * stations-select
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default sb => {
    let stationsSelect;

    const fetchStations = function fetchStations() {
        return sb.postApi("/whats-new/main-stations").then(stations => {
            sb.notify({ type: "stationsLoaded", data: stations });

            return stations;
        });
    };

    const populateStationsSelect = function populateStationsSelect(stations) {
        let options = stations.map(station => {
            return `<option selected value="${station.id}">${station.name}</option>`;
        }).join("\n");

        sb.append(stationsSelect, options);
        onStationsSelectionChange(); // We've added stations selected

        return stations;
    };

    const onStationsSelectionChange = function onStationsSelectionChange() {
        sb.notify({
            type: "stationsSelectionChanged",
            data: [].map.call(
                getSelectedOptions(stationsSelect[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            stationsSelect = sb.find("#station");
            sb.addEvent(stationsSelect[0], "change", onStationsSelectionChange);

            fetchStations().then(populateStationsSelect);
        },
        destroy() {
            sb.removeEvent(stationsSelect[0], "change", onStationsSelectionChange);
            stationsSelect = null;
        }
    }
};
